module.exports = __webpack_public_path__ + "images/taco-sleep.ee2660df9335718b1a80.svg";